import { Instagram } from "lucide-react";
import { BUSINESS } from "../../data/site";

const InstagramFab = () => (
  <a
    href={BUSINESS.instagram}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="instagram-fab"
    aria-label="Follow on Instagram"
    className="fixed bottom-24 right-6 z-[70] hidden h-14 w-14 items-center justify-center rounded-full text-white shadow-lg transition-transform duration-300 hover:scale-110 md:flex"
    style={{
      background:
        "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)",
    }}
  >
    <Instagram className="h-6 w-6" strokeWidth={2} />
  </a>
);

export default InstagramFab;
